module.exports = __webpack_public_path__ + "img/excel.3096c016.png";